// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Backend__IssueController from "./backend/issue_controller"
application.register("backend--issue", Backend__IssueController)

import Backend__IssuesController from "./backend/issues_controller"
application.register("backend--issues", Backend__IssuesController)

import Backend__SortController from "./backend/sort_controller"
application.register("backend--sort", Backend__SortController)

import HandleRelatedController from "./handle_related_controller"
application.register("handle-related", HandleRelatedController)

import SpeechController from "./speech_controller"
application.register("speech", SpeechController)

import PageingController from "./pageing_controller"
application.register("pageing", PageingController)

import SwitchDayNightController from "./switch_day_night_controller"
application.register("switch-day-night", SwitchDayNightController)

import PollIssueController from "./poll_issue_controller"
application.register("poll-issue", PollIssueController)

import UploaderController from "./uploader_controller"
application.register("uploader", UploaderController)

import ModalWindowController from "./modal_window_controller"
application.register("modal-window", ModalWindowController)

import TurboFrameHistroyController from "./turbo_frame_history_controller"
application.register("turbo-frame-history", TurboFrameHistroyController)

import FrontendQuizLoaderController from "./frontend_quiz_loader_controller"
application.register("frontend-quiz-loader", FrontendQuizLoaderController)

import Dropdown from "stimulus-dropdown"
application.register("dropdown", Dropdown)

import ControlTaskController from "./control_task_controller"
application.register("control-task", ControlTaskController)

import TournamentController from "./tournament_controller"
application.register("tournament", TournamentController)

import TournamentAdminController from "./tournament_admin_controller"
application.register("tournament-admin", TournamentAdminController)

import VideoController from "./video_controller"
application.register("video", VideoController)

import DiaryFeelingsController from "./diary_feeling_controller"
application.register("diary-feeling", DiaryFeelingsController)

import ChangeMethodController from "./change_method_controller"
application.register("change-method", ChangeMethodController)

import QuizLoaderController from "./backend/quiz_loader_controller"
application.register("quiz-loader", QuizLoaderController)

